import { Component, OnInit, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
// services
import { ErrorHandler } from '../../../services/error-handler.service';
// models
import { AppState } from '../../../../booking/models/app-state.interface';
import { ModalData } from '../../../models/modal.interface';
// ngrx store
import { Store } from '@ngrx/store';
import { FormsModule } from '@angular/forms';
import { AssociatedFlightsComponent } from '../associated-flights/associated-flights.component';
import { FlightInfoComponent } from '../flight-info/flight-info.component';

declare var ga: any;

@Component({
  selector: 'app-modal-base',
  standalone: true,
  imports: [CommonModule, FormsModule, AssociatedFlightsComponent, FlightInfoComponent],
  templateUrl: './modal-base.component.html',
  styleUrls: ['./modal-base.component.scss']
})

@Injectable({
  providedIn: 'root',
})
export class ModalBaseComponent implements OnInit {

  public modalData: ModalData;
  public modalList: Array<any> = [];
  public scrollPosition = 0;

  constructor(
    public appStore: Store<AppState>,
    public errorService: ErrorHandler,
    public router: Router,
    @Inject(PLATFORM_ID) public platformId: Object
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      this.errorService.modalItem$
      .subscribe(modalItem => {

      if (modalItem === 'remove') {
      this.closeModal();
      return;
      }
          this.create(modalItem);
      });
    }
  }

  create(data: any) {

    if (this.modalList.length > 0) {
      this.modalList.splice(0, 1);
    }

    this.modalList.push(data);
    this.modalData = data;

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-open');
    this.scrollPosition = window.scrollY;
    this.sendGAData(data);

  }

  closeModal() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.modalList = [];

      const bookingPod = document.getElementById('bookingPod')
      if (bookingPod) {
        bookingPod.remove();
      }
      window.scrollTo(0, this.scrollPosition);
    }
  }

  removeClasses() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.closeModal();
    }
  }

  sendGAData(d) {
    if (isPlatformBrowser(this.platformId)) {
      const currentUrl = location.pathname;
      ga('send', 'event', 'Funnel', d.title, currentUrl);
    }
  }

}
